import { Application } from "@hotwired/stimulus";
import { definitionsFromContext } from "@hotwired/stimulus-webpack-helpers";

const application = Application.start();
const context = require.context(".", true, /_controller\.js$/);

application.load(definitionsFromContext(context));

document.addEventListener("turbo:click", async (event) => {
  console.log("turbo:click");
});

document.addEventListener("turbo:before-visit", async (event) => {
  console.log("turbo:before-visit");
});

document.addEventListener("turbo:visit", async (event) => {
  console.log("turbo:visit");
});

document.addEventListener("turbo:render", async (event) => {
  console.log("turbo:render");
});

document.addEventListener("turbo:load", async (event) => {
  console.log("turbo:load");
});

document.addEventListener("turbo:before-visit", async (event) => {
  console.log("turbo:before-visit");
});